// @ts-nocheck
import {ConfEnv} from "../../../config/config";
import privateRequest from "../../../Infra/http/private.request";

export const getHeadbandService = async () => {
  return privateRequest.get(`${ConfEnv.BASE_URL_WALLET}/v1/big-winners`);
};
